export default "__VITE_ASSET__CKoHPpkh__"